module.exports = __webpack_public_path__ + "img/KG.d35765ff.svg";